import type { SurfaceTab } from "./types";

/**
 * Feature-local query-key factory (Files pattern).
 * Hierarchy: all → board(slug) → progress|feed|tags|asset
 */
export const promoteSurfaceKeys = {
  all: ["promoteSurface"] as const,

  board: (slug: string) => [...promoteSurfaceKeys.all, slug] as const,

  progress: (slug: string) => [...promoteSurfaceKeys.board(slug), "progress"] as const,

  feed: (slug: string, tab: SurfaceTab) =>
    [...promoteSurfaceKeys.board(slug), "feed", tab] as const,

  solutionTags: (slug: string) => [...promoteSurfaceKeys.board(slug), "solutionTags"] as const,
} as const;
